<template>
    <div>
        <section class="section section--contact" id="contact">
            <div class="section__form">
                <Heading text="Jak se s námi spojit?" />
                <form action="https://smartforms.dev/submit/5f1fc420d6e76679b483a944" method="POST" class="form">
                    <div class="form__section form__section--first">
                        <div class="form__row form__row--required">
                            <label for="name">Jméno:</label>
                            <input type="text" name="name" class="form__widget" id="name" required />
                        </div>
                        <div class="form__row form__row--required">
                            <label for="email">E-mailová adresa:</label>
                            <input type="email" name="email" class="form__widget" id="email" required />
                        </div>
                        <div class="form__row">
                            <label for="phone">Telefon:</label>
                            <input type="tel" name="phone" class="form__widget" id="phone" />
                        </div>
                    </div>
                    <div class="form__section form__section--second">
                        <div class="form__row form__row--required">
                            <label for="message">Zpráva:</label>
                            <textarea name="message" class="form__widget" id="message"></textarea>
                        </div>
                    </div>
                    <button type="submit" class="btn">Odeslat</button>
                </form>
                <div class="company-info">
                    <h2>Institute of Applied Psychology s.r.o.</h2>
                    <span class="company-info__label">Sídlo</span>
                    <p>Cejl 40/107<br />602 00, Brno-Zábrdovice</p>
                    <span class="company-info__label">Telefon</span>
                    <p><a href="tel:+420725442434">+420 725 442 434</a></p>
                    <span class="company-info__label">E-mailová adresa</span>
                    <p><a href="mailto:office@iapsychology.cz">office@iapsychology.cz</a></p>
                    <ul>
                        <li><a href="https://www.facebook.com/InstituteOfAppliedPsychology" target="_blank"><FontAwesomeIcon :icon="['fab', 'facebook-f']" /></a></li>
                        <li><a href="https://www.linkedin.com/company/institute-of-applied-psychology/" target="_blank"><FontAwesomeIcon :icon="['fab', 'linkedin-in']" /></a></li>
                    </ul>
                </div>
            </div>
            <a href="https://mapy.cz/s/junukegeso" target="_blank" class="section__map">
                <picture>
                    <source media="(min-width: 1200px)" srcset="../assets/map-lg.jpg 1x, ../assets/map-lg-2x.jpg 2x">
                    <source media="(min-width: 768px)" srcset="../assets/map-md.jpg 1x, ../assets/map-md-2x.jpg 2x">
                    <source srcset="../assets/map-sm.jpg 1x, ../assets/map-sm-2x.jpg 2x">
                    <img src="../assets/map-lg.jpg" loading="lazy" />
                </picture>
            </a>
        </section>
        <footer>
            <p class="copyright">Copyright &copy; {{ (new Date()).getFullYear() }} Institute of Applied Psychology s.r.o.</p>
            <p class="author">Vytvořil <a href="https://www.janmachac.eu" target="_blank">Jan Macháč</a></p>
        </footer>
    </div>
</template>

<script>
    import Heading from './includes/Heading.vue';
    import { library } from '@fortawesome/fontawesome-svg-core'; 
    import { faLinkedinIn, faFacebookF } from '@fortawesome/free-brands-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    library.add(faLinkedinIn);
    library.add(faFacebookF);

    export default {
        name: 'Contact',
        components: {
            Heading,
            FontAwesomeIcon
        }
    }
</script>

<style lang="scss" scoped>

    .heading {
        width: 100%;
        margin-bottom: 2rem;
    }
    
    .section {

        &__form {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;
            max-width: 1200px;
            padding: 8rem;
            margin: 0 auto;
        }

        .form {
            width: 45%;
        }

        .company-info {
            width: 48%;
            padding: 4rem;
            border-radius: 5px;
            margin-top: 2.5rem;
            text-align: center;
            background-color: #fff;
            box-shadow: 0 0 14px -12px #9a9a9a;

            h2 {
                margin-top: 0;
                margin-bottom: 3rem;
                font-family: 'Roboto Slab', sans-serif;
                font-weight: 400;
            }

            &__label {
                display: block;
                margin-bottom: 1rem;
                text-transform: uppercase;
                font-size: 1.4rem;
                color: #adb8d2;

                + p {
                    margin: 0 0 4rem 0;

                    a {
                        text-decoration: none;
                    }

                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
            }

            ul {
                display: flex;
                justify-content: center;
                width: 100%;
                padding: 0;
                margin: 3rem 0 0 0;

                li {
                    list-style-type: none;
                    margin: 0 1rem;

                    a {
                        display: block;
                        width: 6rem;
                        height: 6rem;
                        border-radius: 50%;
                        line-height: 6.1rem;
                        font-size: 2rem;
                        background-color: #333;
                        
                        svg path {
                            color: #fff
                        }
                    }
                }
            }
        }

        &__map {
            
            img {
                display: block;
                width: 100%;
            }
        }

        &--contact {
            padding: 0;
            background-color: #f3f5f8;
        }
    }

    .form {

        label {
            display: block;
            width: 100%;
            margin-bottom: 1rem;
            font-size: 1.6rem;
            font-weight: 600;
        }

        &__row {
            width: 100%;
            margin-bottom: 2rem;

            &--required {

                label::after {
                    margin-left: .5rem;
                    color: red;
                    content: "*";
                }
            }
        }

        &__widget {
            width: 100%;
            padding: 1rem;
            border: 1px solid #bbb;
            border-radius: 5px;
            font-size: 1.6rem;
            font-family: 'Roboto', sans-serif;
        }

        textarea {
            min-height: 15rem;
        }
    }

    footer {
        padding: 4rem;
        text-align: center;
        background-color: #333;

        p {
            color: #fff;

            &.author {
                color: #aaa;

                a {
                    color: #aaa;
                }
            }
        }
    }

    @media (max-width: 999px) {

        .section {

            .form,
            .company-info {
                width: 47%;
            }

            &__form {
                padding: 4rem;
            }
        }
    }

    @media (max-width: 767px) {

        .section {

            .form,
            .company-info {
                width: 100%;
            }

            .company-info {
                margin-top: 6rem;
            }

            &__form {
                padding: 4rem 2rem;
            }
        }
    }

</style>
